// @flow

export function getSortedDisabilityTypeIDs(disabilityTypes) {
  const disabilityIDs = Object.keys(disabilityTypes);
  disabilityIDs.sort((a, b) => disabilityTypes[parseFloat(a)].sort_id
    - disabilityTypes[parseFloat(b)].sort_id);
  return disabilityIDs;
}
